module.exports = __webpack_public_path__ + "img/carnet.36095ed8.svg";